import { render, staticRenderFns } from "./siren.vue?vue&type=template&id=d1e3daa2&scoped=true"
import script from "./siren.vue?vue&type=script&lang=js"
export * from "./siren.vue?vue&type=script&lang=js"
import style0 from "./siren.vue?vue&type=style&index=0&id=d1e3daa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e3daa2",
  null
  
)

export default component.exports